module.exports = __webpack_public_path__ + "static/media/HomeImg2.f8a10f8a.png";